import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@base/environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgencyModulesService {
  constructor(private readonly http: HttpClient) {}

  async getModuleIds(agencyId: number, accessToken: string): Promise<string[]> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });
    const response = await firstValueFrom(
      this.http.get<{ modulesAssign?: Record<string, string> }>(
        `${environment.apiEndpoint}/agency/${agencyId}/`,
        { headers },
      ),
    );
    return Object.keys(response?.modulesAssign ?? {});
  }
}
